import React from 'react';
import { Route, Routes } from 'react-router-dom';

import Layout from '../layout/Layout';
import Calendar from '../components/Calendar';
import Chat from '../components/Chat';
import Organizations from '../components/Organizations';
import OrganizationDetails from '../components/OrganizationDetails';
import AllComments from '../components/AllComments';
import Books from '../components/Books';
import BookView from '../components/Books/BookView';
import Goals from '../components/Goals';
import GoalView from '../components/Goals/GoalView';
import Settings from '../components/Settings';
import Admin from '../components/Admin';

export default (
  <Layout>
    <Routes>
      <Route path="/calendar" element={<Calendar />} />
      <Route path="/chat" element={<Chat />} />
      <Route path="/organizations" element={<Organizations />} />
      <Route path="/organizations/:id" element={<OrganizationDetails />} />
      <Route path="/comments" element={<AllComments />} />
      <Route path="/books" element={<Books />} />
      <Route path="/books/:id" element={<BookView />} />
      <Route path="/goals" element={<Goals />} />
      <Route path="/goals/:id" element={<GoalView />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/admin" element={<Admin />} />
    </Routes>
  </Layout>
);
